module.exports = __webpack_public_path__ + "static/media/827.33ca6004.svg";